// ── تبدیل ارقام فارسی/عربی به انگلیسی برای ورودی شماره تلفن ──────────────────
// کیبورد فارسی گوشی/ویندوز به‌صورت پیش‌فرض ارقام ۰۱۲۳۴۵۶۷۸۹ (و گاهی عربی
// ٠١٢٣٤٥٦٧٨٩) تولید می‌کند. اگر این ارقام همان‌طور که هستند به سرور فرستاده
// شوند، پیامک هرگز نمی‌رسد — بک‌اند آن‌ها را رقم نمی‌شناسد و به‌جای تبدیل،
// حذفشان می‌کند. این تابع همان لحظه‌ی تایپ (روی کلاینت) تبدیل را انجام می‌دهد
// تا مقداری که کاربر می‌بیند و مقداری که فرستاده می‌شود همیشه ارقام انگلیسی باشد.
const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹';
const ARABIC_DIGITS = '٠١٢٣٤٥٦٧٨٩';

export function toEnglishDigits(input) {
  let s = String(input ?? '');
  s = s.replace(/[۰-۹]/g, (d) => String(PERSIAN_DIGITS.indexOf(d)));
  s = s.replace(/[٠-٩]/g, (d) => String(ARABIC_DIGITS.indexOf(d)));
  return s;
}

/**
 * برای فیلدهای ورودی شماره موبایل: ارقام فارسی/عربی را به انگلیسی تبدیل،
 * هر کاراکتر غیرعددی (فاصله، خط تیره، +۹۸ و ...) را حذف، و در صورت نیاز طول
 * را محدود می‌کند (پیش‌فرض ۱۱ رقم — فرمت ۰۹XXXXXXXXX).
 */
export function sanitizePhoneInput(input, maxLength = 11) {
  const digitsOnly = toEnglishDigits(input).replace(/\D/g, '');
  return maxLength ? digitsOnly.slice(0, maxLength) : digitsOnly;
}
